<template>
  <v-list-item type="subheader">Year</v-list-item>
  <v-list-item prepend-icon="mdi-home"
    ><router-link class="nav-item nav-link" :to="{ name: 'Admin' }">Home</router-link></v-list-item
  >

  <v-select
    v-model="selectedYearId"
    label="Year"
    :items="years"
    item-value="id"
    item-title="year"
    outlined></v-select>

  <v-list-item type="subheader">Administration</v-list-item>
  <v-list-item prepend-icon="mdi-map-marker"
    ><router-link class="nav-item nav-link" :to="{ name: 'AdminBranchListing' }"
      >Branches</router-link
    ></v-list-item
  >

  <v-list-item prepend-icon="mdi-account"
    ><router-link class="nav-item nav-link" :to="{ name: 'AdminUserListing' }"
      >Users</router-link
    ></v-list-item
  >
  <v-list-item prepend-icon="mdi-calendar-blank"
    ><router-link class="nav-item nav-link" :to="{ name: 'AdminYearListing' }"
      >Years</router-link
    ></v-list-item
  >
  <v-list-item prepend-icon="mdi-account-group">
    <router-link class="nav-item nav-link" :to="{ name: 'AdminTeamListing' }"
      >Teams</router-link
    ></v-list-item
  >
  <v-list-item prepend-icon="mdi-trophy-outline">
    <router-link
      class="nav-item nav-link"
      :to="{ name: 'AdminJudgeYearEdit', params: { yearId: selectedYearId } }"
      >Judging</router-link
    ></v-list-item
  >

  <v-divider></v-divider>
  <v-list-item prepend-icon="mdi-email-outline">
    <router-link class="nav-item nav-link" :to="{ name: 'AdminEmailTemplateListings' }"
      >Email Templates</router-link
    ></v-list-item
  >
  <v-list-item prepend-icon="mdi-form-select">
    <router-link class="nav-item nav-link" :to="{ name: 'AdminFormTemplateListings' }"
      >Form Templates</router-link
    ></v-list-item
  >
  <v-divider></v-divider>
  <v-list-item prepend-icon="mdi-cog"
    ><router-link class="nav-item nav-link" :to="{ name: 'AdminSettings' }"
      >Settings</router-link
    ></v-list-item
  >
</template>
<script setup lang="ts">
import { PaginationDTO } from '@/dtos';
import { useYearStore } from '@/stores/index';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';

const yearStore = useYearStore();
const { data: yearData } = yearStore.getYearsQuery(ref(new PaginationDTO()));

const years = computed(() => yearData.value?.data);
const { selectedYearId } = storeToRefs(yearStore);
</script>
<script lang="ts">
export default {
  name: 'NavBarAdmin',
};
</script>

<style></style>
